import { FC } from 'react';

import { Link } from '@inertiajs/react';

import { Routes } from '../../../models/routes';
import { cn } from '../../../utils';

export type ReviewsTab = 'pending' | 'written';

interface Props {
    activeTab: ReviewsTab;
    counts: Record<ReviewsTab, number>;
}

const tabs: Array<{ value: ReviewsTab; label: string }> = [
    { value: 'pending', label: 'Очікують відгуку' },
    { value: 'written', label: 'Мої відгуки' },
];

export const ReviewTabs: FC<Props> = ({ activeTab, counts }) => {
    return (
        <nav
            className="flex flex-wrap gap-2"
            aria-label="Розділи моїх відгуків"
        >
            {tabs.map((tab) => {
                const active = activeTab === tab.value;

                return (
                    <Link
                        key={tab.value}
                        href={`${Routes.Reviews}?tab=${tab.value}`}
                        className={cn(
                            'inline-flex h-10 items-center justify-center gap-2 rounded-xl border px-4 text-sm font-semibold transition-colors',
                            'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none',
                            active
                                ? 'border-primary bg-primary text-primary-foreground'
                                : 'border-primary/60 bg-background text-foreground hover:bg-primary/5',
                        )}
                        aria-current={active ? 'page' : undefined}
                    >
                        {tab.label}
                        <span
                            className={cn(
                                'inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[11px]',
                                active
                                    ? 'bg-primary-foreground/20 text-primary-foreground'
                                    : 'bg-primary/10 text-primary',
                            )}
                        >
                            {counts[tab.value]}
                        </span>
                    </Link>
                );
            })}
        </nav>
    );
};
